import { render, staticRenderFns } from "./VincularPerfilCadastro.vue?vue&type=template&id=7845eca7&"
import script from "./VincularPerfilCadastro.vue?vue&type=script&lang=js&"
export * from "./VincularPerfilCadastro.vue?vue&type=script&lang=js&"
import style0 from "./VincularPerfilCadastro.vue?vue&type=style&index=0&id=7845eca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports